import React, { useEffect, useState, useCallback } from "react";
import styles from "./Home.module.css";
import SearchBar from "../../Components/Home/SearchBar/SearchBar";
import StoryList from "../../Components/Home/StoryList/StoryList";
import { fetchPublicStories } from "../../config/data";
import { debounce } from "../../utils/helpers"; // Add this import

const Home = () => {
  const [stories, setStories] = useState([]);
  const [filteredStories, setFilteredStories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const storiesPerPage = 9;

  const loadMoreStories = useCallback(async () => {
    if (loading || !hasMore) return;

    setLoading(true);

    const data = await fetchPublicStories(currentPage, storiesPerPage);
    if (data.length === 0) {
      setHasMore(false);
    } else {
      const sortedStories = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setStories((prevStories) => [...prevStories, ...sortedStories]);
      setFilteredStories((prevStories) => [...prevStories, ...sortedStories]); // Update filtered stories too
      setCurrentPage((prevPage) => prevPage + 1);
    }

    setLoading(false);
  }, [currentPage, loading, hasMore]);

    useEffect(() => {
    const handleScroll = debounce(() => {
      const scrolledToBottom = 
        window.innerHeight + window.pageYOffset >= 
        document.documentElement.offsetHeight - 200;

      if (scrolledToBottom && !loading && hasMore && !searchQuery) {
        loadMoreStories();
      }
    }, 200);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [loadMoreStories, loading, hasMore, searchQuery]);

  useEffect(() => {
    loadMoreStories();
  }, []);

  const handleSearchKey = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (query) {
      const filtered = stories.filter((story) =>
        story.title.toLowerCase().includes(query.toLowerCase()) ||
        story.content.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredStories(filtered);
    } else {
      setFilteredStories(stories);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
    setFilteredStories(stories);
  };

  return (
    <div className={styles.home}>
      <SearchBar
        value={searchQuery}
        handleSearchKey={handleSearchKey}
        clearSearch={clearSearch}
        formSubmit={(e) => e.preventDefault()}
      />
      <StoryList stories={filteredStories} />
      {loading && <p>Loading more stories...</p>}
      {!hasMore && <p>No more stories available</p>}
    </div>
  );
};

export default Home;
